/* W-01 planner: header with day chips and search; the timeline beside the day map. */
.page {
  display: grid;
  grid-template-rows: auto auto 1fr;
  height: 100vh;
}
.pad {
  padding: var(--dimension-space-4) var(--gutter);
}
.muted {
  color: var(--color-text-secondary);
}
.top {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: end;
  gap: var(--dimension-space-4);
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
  background: var(--color-surface-base);
}
.kicker {
  color: var(--color-text-tertiary);
}
.dayline {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-3);
}
.dayline h1 {
  margin: 0;
}
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--dimension-space-1);
}
.chip {
  min-width: 32px;
  height: 28px;
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
  border-radius: var(--dimension-radius-xs);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
}
.chipOn {
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
  border-color: var(--color-surface-inverse);
}
/* Today's chip is signal, chosen or not (W-01). */
.chipToday {
  background: var(--color-surface-signal);
  color: var(--color-text-on-signal);
  border-color: var(--color-surface-signal);
}
.search {
  position: relative;
  display: flex;
  gap: var(--dimension-space-2);
  align-items: center;
}
.searchBox {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
  width: 280px;
  height: 40px;
  padding: 0 var(--dimension-space-3);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  background: var(--color-surface-raised);
  color: var(--color-text-secondary);
}
.searchBox input {
  flex: 1;
  min-width: 0;
  border: 0;
  background: none;
  color: var(--color-text-primary);
  outline: none;
}
:where(.searchBox input) {
  font: inherit;
}
.searchBox button {
  border: 0;
  background: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
}
.results {
  position: absolute;
  top: 44px;
  left: 0;
  z-index: 5;
  width: 360px;
  max-height: 60vh;
  overflow: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
}
.results button {
  display: grid;
  gap: 2px;
  width: 100%;
  padding: var(--dimension-space-2) var(--dimension-space-3);
  border: 0;
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
  background: none;
  color: var(--color-text-primary);
  text-align: left;
  cursor: pointer;
}
.results button:hover,
.results button:focus-visible {
  background: var(--color-surface-sunken);
}
.notice {
  margin: 0;
  padding: var(--dimension-space-2) var(--dimension-space-5);
  background: var(--color-surface-sunken);
}
.body {
  display: grid;
  grid-template-columns: minmax(380px, 520px) 1fr;
  min-height: 0;
}
.timeline {
  overflow: auto;
  border-right: var(--dimension-line-hairline) solid var(--color-border-hairline);
  padding-bottom: var(--dimension-space-8);
}
.stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dimension-space-3) var(--dimension-space-4);
}
.rows {
  margin: 0;
  padding: 0 var(--dimension-space-4) 0 0;
  list-style: none;
  min-height: var(--dimension-space-6);
}
.row {
  position: relative;
  cursor: grab;
  border-top: 2px solid transparent;
}
.selectedRow {
  background: var(--color-surface-sunken);
}
.dropBefore {
  border-top-color: var(--color-surface-signal);
}
.rowTools {
  position: absolute;
  top: var(--dimension-space-2);
  right: 0;
  display: flex;
  align-items: center;
  gap: var(--dimension-space-1);
  padding: 0 var(--dimension-space-2);
  /* Over the stop ID while shown, not on top of it. */
  background: var(--color-surface-base);
  opacity: 0;
  pointer-events: none;
}
.row:hover .rowTools,
.row:focus-within .rowTools {
  opacity: 1;
  pointer-events: auto;
}
.tool {
  border: 0;
  background: none;
  color: var(--color-text-tertiary);
  cursor: pointer;
  padding: var(--dimension-space-1);
}
.tool:hover {
  color: var(--color-text-primary);
}
.moveTo {
  max-width: 120px;
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
}
.flat {
  margin: 0;
}
.list {
  margin-top: var(--dimension-space-5);
}
.listHead {
  display: flex;
  justify-content: space-between;
  padding: var(--dimension-space-2) var(--dimension-space-4);
  border-top: var(--dimension-line-control) solid var(--color-text-primary);
}
.mapCol {
  position: relative;
  min-height: 0;
}
.mapWrap {
  position: absolute;
  inset: 0;
}
.mapWrap > :first-child {
  height: 100%;
}
.legend {
  position: absolute;
  top: var(--dimension-space-4);
  left: var(--dimension-space-4);
}
.card {
  position: absolute;
  left: var(--dimension-space-4);
  right: var(--dimension-space-4);
  bottom: var(--dimension-space-4);
  max-width: 400px;
}
@media (max-width: 899px) {
  .page {
    height: auto;
  }
  .top,
  .body {
    grid-template-columns: 1fr;
  }
  .mapCol {
    height: 50vh;
  }
}
